import {ref} from 'vue';
import {defineStore} from 'pinia';

import {getAppContext} from '@/core/plugins/appContext';

export const useOfficesAtmsTerminalsStore = defineStore('offices-atms-terminals', () => {
    const {$api} = getAppContext();

    const officesList = ref([]);
    const atmsList = ref([]);
    const terminalsList = ref([]);
    const remoteRecordingOffice = ref(null);

    function setOfficesList(offices = []) {
        officesList.value = offices;
    }

    function setAtmsList(atms = []) {
        atmsList.value = atms;
    }

    function setTerminalsList(terminals = []) {
        terminalsList.value = terminals;
    }

    function setRemoteRecordingOffice(office = null) {
        remoteRecordingOffice.value = office;
    }

    async function getOfficeDetails(slug) {
        try {
            const {data} = await $api.referenceData.office(slug);

            return data;
        } catch (error) {
            console.error(error);
        }
    }

    async function getOfficesList({payload = {}, params = {}} = {}) {
        if (officesList.value.length) {
            return;
        }

        try {
            const body = Object.assign({}, payload, {type: 'front.list', ...params});
            const {data} = await $api.referenceData.offices(body);
            setOfficesList(data.data);

            return data.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    async function getAtmsList(payload) {
        try {
            const {data} = await $api.referenceData.atms(payload);
            setAtmsList(data.data);

            return data.data;
        } catch (error) {
            console.error(error);
        }
    }

    async function getTerminalsList(payload) {
        try {
            const {data} = await $api.referenceData.terminals(payload);
            setTerminalsList(data.data);

            return data.data;
        } catch (error) {
            console.error(error);
        }
    }

    return {
        officesList,
        atmsList,
        terminalsList,
        remoteRecordingOffice,
        setOfficesList,
        setAtmsList,
        setTerminalsList,
        setRemoteRecordingOffice,
        getOfficesList,
        getAtmsList,
        getTerminalsList,
        getOfficeDetails,
    };
});
